<template lang="pug">
  div
    .step-content
      .shop-form
        slot
        el-col 1.寄件人姓名：{{ details.userName }}
        el-col 2.寄件人手機：{{ details.userTel }}
        el-col 3.收件地址：{{ details.recipient_address }}
        
        div(v-if="shippingMethod==1")
          el-col 4.還件地址：{{ details.return_address }}
          el-col 5.可收件時間：{{ moment(new Date(details.recipient_sdate)).format("YYYY-MM-DD HH:mm") }} ~ {{ moment(new Date(details.recipient_edate)).format("HH:mm") }}
          el-col 6.可還件時間：{{ moment(new Date(details.return_sdate)).format("YYYY-MM-DD HH:mm") }} ~ {{ moment(new Date(details.return_edate)).format("HH:mm") }}
          el-col 7.送洗袋數：{{ details.bags_number }} 袋
          el-col 8.服務項目 ：
            div(v-show="details.service_items.length < 1") 無
            div(v-for="(v,k) in service_items_data" v-show="details.service_items.indexOf(k) !== -1") <div style="color: #d4d4d4;font-size: 13px;line-height: 1.5;"><input type="checkbox" checked disabled/> {{v}}</div>
          el-col 9.額外加購項目（每袋）：
            div(v-show="details.purchase_item.length < 1") 無
            div(v-for="(v,k) in purchase_item_data" v-show="details.purchase_item.indexOf(k) !== -1") <div style="color: #d4d4d4;font-size: 13px;line-height: 1.5;"><input type="checkbox" checked disabled/> {{v}}</div>
          el-col 10.補充說明：
            div {{details.other}}
          
      

        div(v-if="shippingMethod==2")
          el-col 4.請輸入所需格數：{{ details.grids_number }}
          el-form-item(label='5.服務項目 ：(如果您不確定,請選基本洗衣服務即可,客服會在Line@中與您討論)' prop="service_items")
            el-checkbox-group(v-model="details.service_items")
              div(v-for="(v, no) in service_items_data" :key="no")
                el-checkbox(:label="no") v
          el-col 5.服務項目 ：
            div(v-show="details.service_items.length < 1") 無
            div(v-for="(v,k) in service_items_data" v-show="details.service_items.indexOf(k) !== -1") <div style="color: #d4d4d4;font-size: 13px;line-height: 1.5;"><input type="checkbox" checked disabled/> {{v}}</div>
          el-col 6.額外加購項目（每袋）：
            div(v-show="details.purchase_item.length < 1") 無
            div(v-for="(v,k) in purchase_item_data" v-show="details.purchase_item.indexOf(k) !== -1") <div style="color: #d4d4d4;font-size: 13px;line-height: 1.5;"><input type="checkbox" checked disabled/> {{v}}</div>
          // el-col 7.您所選擇的櫃機：
          el-col 7.您所選擇的機櫃：
            UL(style="background-color: rgba(70, 70, 70, 0.2);line-height: 2;" )
              LI
                input(id="pb_ecmap_code" style="background-color:transparent;border:0" v-model="pbEcmap__.pb_ecmap_code" value="" disabled)
              LI 櫃機場所：
                input(id="pb_ecmap_name" style="background-color:transparent;border:0" v-model="pbEcmap__.pb_ecmap_name" disabled)
              LI 櫃機地址：
                input(id="pb_ecmap_addr" style="background-color:transparent;border:0;width: 100%;" v-model="pbEcmap__.pb_ecmap_addr" disabled)
          el-col(v-show="show_coupon")
            div(style="border-top:1px dashed #cccccc;height: 1px;overflow:hidden;margin: 40px 0px 20px 0px;")
            div(style="width:25%;display: inline-block;") 優惠券：
            input(style="border: 1px solid rgb(204, 204, 204);border-radius: 7px;width: 70%;height: 28px;background-color: rgb(226, 226, 226);text-align: center;margin: 10px 0 10px 0;color: #d4d4d4;" :value="'折扣50元('+coupon_id+')'" disabled)
        // hr
        el-checkbox(v-model="need_save_service" style="width: 100%;margin-left: 10px;display: inline-flex;margin-top: 10px;margin-bottom: 10px" label="1" key="1") 記住這次選擇的服務項目
        
    .cart__footer(class="new-footer")
      el-col(:span="12")
        el-button.white-button(type="button" style="float:left;"  @click="goBack") 上一步
      el-col(:span="12")
        el-button.black-button(type="button" style="float:right;" @click='agreeDialog = true') 確認無誤

    el-dialog(
      width="80%"
      title="請同意條款"
      :visible.sync="agreeDialog"
      center)
      div(style="height:50vh;overflow:auto;overflow-x:hidden;border-style: dotted;border-width:1px; border-color:#939699;") 
        div(v-html="agreeMsg")
      div(style="padding-top:20px")
        <el-tooltip placement="top">
          <div slot="content">清點數量在發生疑似遺失短少狀況時, <br/>可以跟公司申請進行清查, 了解是否有衣物短少, <br/>未購買此服務者一律不協助也不可申張進行可能遺失之追查</div>
          <el-checkbox class="tos" v-model="is_need_check_count">我要清點數量服務(每袋清點費用 540 元)</el-checkbox> 
        </el-tooltip>
      div(style="padding-top:5px")
        <el-tooltip placement="top">
          <div slot="content">勾選此項目表示不需要幫我進行分檢, <br/>我已經妥善確認我的衣物可以符合標準清洗(機洗+高溫烘乾) 的方式, <br/>收到後不需改報價直接清洗即可</div>
          <el-checkbox class="tos" v-model="is_only_wash">只需要基本清洗不需要進行分檢</el-checkbox>
        </el-tooltip>
      span(slot="footer" class="dialog-footer")
        el-button.white-button(type="button" @click="agreeDialog = false") 不同意
        el-button.black-button(@click="submit") 我同意
</template>

<style lang="scss" scoped src="./style.scss"></style>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { Loading } from 'element-ui'
import { createOrder } from '@/api/index'
import { couponList } from '@/api/index'

const msg = `親愛的用戶您好, 基於您完成預約後即代表同意以下之條款:<br/>

<ol>
<li>衣服的清洗方式會由您來決定, 如果您有特別在意的髒汙需要特殊處理的衣物的話也請先勾選特殊除汙, 或有特別會被烘壞的衣服需要晾曬的話，也請先勾選晾曬，然後跟我們溝通，那我們也會在收到衣服後給您建議的清洗方式, 但是最終還是由您這邊做最後的決定, 我們不會對清洗方式負責．</li>
<li>如果您不太清楚衣服的分類需要我們幫您分檢, 我們可以幫您做這項服務, 我們分檢一定比您專業, 但是為避免有些地方連我們都沒看到或判斷不到的, 會有爭議, 所以我們不會對分檢的結果負責, 您如果同意的話我們就幫您做分檢.</li>
<li>收件回來經過報價後, 如果您不同意我們的報價就會進入到退件程序, 針對退件的部份會酌收每袋 150-250 元的運費。</li>
<li>相較於坊間以一件一件衣服跟您計算價格的乾洗店或洗衣店, 易立洗採取的是以袋計價, 不計件數, 是整批量清洗的概念, 所以不會幫您做衣物的數量清點計算.</li>
<li>衣物口袋內如果有筆, 口紅, 衛生紙, 小物品等等造成衣物清洗後之污損不屬於公司的責任範圍, 請送洗前先自行檢查取出.</li>
<li>易立洗採整批清洗概念, 不進行清點, 因此如果有衣物遺失之狀況將因無法認證故無法負責, 我們會善盡保管之責任但無法對無法舉證之遺失進行賠償</li>
<li>如果經舉證有遺失或損傷的狀況發生, 我們會提供最高一件衣服 250 元, 一袋衣物 1000 元的賠償金額以作為補償。如果您覺得衣物的價位較高， 無法接受這樣額度的賠償金額，請勿送洗。</li>
<li>衣物清洗後如果產生了損傷, 因為清洗方式是由您決定所以易立洗將無法對您決定後的清洗後果負責, 詳請參閱第一點與第二點.</li>
<li>如果您對收到的衣服有疑慮, 也請在七天之內進行疑問的提出, 超過期限後的狀況申訴易立洗有權不受理, 所以收到送洗回來的衣服後, 建議您盡快拆封檢查或放回衣櫃中保存。同時考慮機器容量與設備存檔能力, 錄影以保存七天為限, 超過七天後的影像資料將會被覆蓋。</li>
<li>送件的報價與袋數之計算一律以易立洗正式報價為準, 任何客戶自行計算與收件前的討論估算之金額僅客戶自己參考, 不能同意者請勿預約.</li>
</ol>`


export default {
  name: 'CartPayment',
  props: {
    details: {
      type: Object,
      required: true
    },
    pbEcmap: {
      type: Object
    },
    shippingMethod: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      agreeDialog: false,
      agreeMsg:"國家發展委員會（以下簡稱本會）係依據本服務條款提供本站各項服務。當您註冊完成或開始使用本服務時，即表示您已閱讀、了解並同意接受本服務條款之所有內容。如果您不同意本服務條款的內容，或者您所屬的國家或地域排除本服務條款內容之全部或部分時，您應立即停止使用本服務。此外，當您使用本服務之特定功能時，可能會依據該特定功能之性質，而須遵守本服務所另行公告之服務條款或相關規定。此另行公告之服務條款或相關規定亦均併入屬於本服務條款之一部分。本會有權於任何時間修改或變更本服務條款之內容，並公告於本服務網站上，請您隨時注意該等修改或變更。若您於任何修改或變更後繼續使用本服務，則視為您已閱讀、了解並同意接受該等修改或變更。若您為未滿二十歲之未成年人，則應請您的父母或監護人閱讀、了解並同意本服務條款之所有內容及其後之修改變更，方得使用本服務。當您使用本服務時，即推定您的父母或監護人已閱讀、了解並同意接受本服務條款之所有內容及其後之修改變更。",
      coupon_id: '',
      show_coupon: false,
      pbEcmap__: this.pbEcmap,
      disabled: true,
      cardType: '卡號',
      status: { number: 1, expiry: 1, cvc: 1 },
      statusClass: ['has-success', '', 'has-error'],
      loading: '',
      need_save_service: true,
      is_need_check_count: false,
      is_only_wash: false,
      service_items_data: {
        1: '1.基本洗衣服務 原價NT$480 (含基本水洗+高溫烘乾+折疊)',
        2: '2.大型床組 (3大條) NT$550 (清洗 床罩組, 被單, 保潔墊, 涼被)(未鋪棉)',
        3: '3.清洗冬天棉被/毛毯一床 NT$550 (請確認您的棉被可以水洗)',
        4: '4.窗簾組清洗-- 另外報價 (窗簾因為材質厚薄差異很大, 且不能烘乾, 所以會在收件後另外報價)',
        // 5: '5.急件費用 NT$300', // 送到後端再改回來
      },
      purchase_item_data: {
        1: '1.額外加購分色/分槽清洗 NT$150 (分二槽水洗+分二槽高溫烘乾)',
        2: '2.額外加購低溫烘乾 NT$150 (全程使用低溫烘乾)',
        3: '3.額外襯衫刷洗每件加價 NT$20',
        4: '4.清洗羽絨外套每件加價 NT$50',
        5: '5.鋪棉床單/鋪棉被單/鋪棉保潔墊/鋪棉四季被/薄毛毯/床裙 每件加價NT$50 (需搭配 550 元床組袋)',
        6: '6.風乾晾曬每件 NT$20',
        7: '7.特殊髒污清洗費用每件 NT$150',
        8: '8.急件費用 NT$300',
      }
    }
  },
  
  created() {
    this.$emit('setStep', 2)
    if(!this.details){
      console.log(this.details)
      this.$router.replace({ name: 'info' })
    }

    // 查詢優惠
    couponList({userTel: this.details.userTel}).then(res=>{
      console.log(res.data)
      if(res.data.length > 0){
        this.coupon_id = res.data[0]['coupon_id']
        this.show_coupon = true
      }else{
        this.show_coupon = false
      }
    })
    this.agreeMsg = msg
  },
  computed: {
    btnStyleClass () {
      return this.disabled ? 'btn-secondary' : 'btn-primary'
    },
    ...mapState('cart', ['cart']),
    ...mapGetters('cart', ['total'])
  },
  methods: {
    ...mapMutations('cart', ['resetCart']),
    openLodaing (text) {
      const loadingOption = { text }
      this.loading = Loading.service(loadingOption)
    },
    goBack () {
      this.$router.go(-1)
    },
    submit () {
      this.openLodaing('送出訂單中')
      this.sendOrder();
      // this.$refs['form'].validate(valid => {
        // if (!valid) return false
        // this.$emit('setStep', 1)
        // this.$router.push({ name: 'payment' })
      // })
    },
    sendOrder (result) {
      // const createOrderParams = {
      //   // prime: result.card.prime,
      //   // details: this.details,
      //   // amount: this.total,
      //   // order: this.cart
      //   // userName: this.details.name,
      //   // userTel: this.details.tel
      //   // this.details
      // }

      // 送出前 急件改回來
      let urgentIndex = this.details.purchase_item.indexOf("8")
      if(urgentIndex != -1){
        this.details.service_items.push("5") // 加入急件
        this.details.purchase_item.splice(urgentIndex, 1); // 刪除急件
      }

      var createOrderParams = Object.assign(this.details, {shipping_method: this.shippingMethod}, {need_save_service: this.need_save_service}, {is_only_wash: this.is_only_wash}, {is_need_check_count: this.is_need_check_count});
      createOrder(createOrderParams).then(this.responseHandler)
    },
    responseHandler (res) {
      this.loading.close()
      let code = res.data.code;
      console.log("寄件馬：", code)
      this.$emit('setCode', code)


      let new_coupon_id = res.data.new_coupon_id;
      console.log("new_coupon_id:", new_coupon_id)
      this.$emit('set_newCouponId', new_coupon_id)

      this.$router.push({ name: 'payment' })
      // code === 0 訂單成立
      // code === 1 庫存不足
      // code === 2 付款失敗
      // code === 3 db fail
      // switch (res.data.code) {
      //   case 0:
      //     this.resetCart()
      //     this.openAlert('已經收到您的費用，商品即將寄出，有任何問題請聯絡：service@tapbee.cc', '付款成功')
      //     break
      //   case 1:
      //     this.openAlert('請重新選擇', '商品庫存不足')
      //     break
      //   case 2:
      //     this.openAlert('請重新操作', '付款失敗，請確認您的交易卡片資料')
      //     break
      //   case 3:
      //     this.openAlert('請稍候', '系統維修中')
      //     break
      }
    },
    openAlert (content, title) {
      this.$alert(content, title, {
        confirmButtonText: '確認',
        callback: action => {
          // this.$router.push({ name: 'entry' })
          this.$router.push({ name: 'cart' })
        }
      })
    },
    forceBlurIos () {
      const isIos =
        /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
      if (!isIos) {
        return
      }
      var input = document.createElement('input')
      input.setAttribute('type', 'text')
      // Insert to active element to ensure scroll lands somewhere relevant
      document.activeElement.prepend(input)
      input.focus()
      input.parentNode.removeChild(input)
    }
  }
  // created () {
    // this.openLodaing()
  // },
  // mounted () {
    // this.tappay()
    // const tappayIframes = document.querySelectorAll('iframe')
    // tappayIframes.forEach(iframe => {
    //   iframe.addEventListener('load', this.iframeLoaded)
    // })
  // }
// }

</script>

<style >
.el-checkbox__label {
  	display: inline-flex;white-space: pre-line;word-wrap: break-word;overflow: hidden;line-height: 20px;
}
.tos .el-checkbox__label {
  color: grey;
  display: inline;
}
.tos .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #007bff;
}
.el-col {
      line-height: 3;
      padding-top: 8px;
}
</style>

<style lang="scss" scoped >
// @media (min-width: 800px) {

//   .cart__footer {
//     width: 75vw;
//   }
// }
// @media (min-width: 1000px) {

//   .cart__footer {
//     width: 65vw;
//   }
// }
</style>